<template>
    <div class="home">
        <h2 class="mb-3">Help</h2>
        <v-container fill-height class="pt-4">
            <v-text-field v-model="searchText"
                          append-icon="mdi-magnify"
                          label="Search"
                          single-line
                          class="mb-3"
                          hide-details></v-text-field>


            <v-progress-linear indeterminate
                               v-show="isBusy"
                               color="primary"></v-progress-linear>


            <v-expansion-panels accordion>
                <v-expansion-panel v-for="(help, i) in helpGuides"
                                   :key="i">
                    <v-expansion-panel-header @click="onGetHelpHtmlDescription(help.id)" class="align-start">
                        {{help.title}} 
                        <v-progress-circular indeterminate align="left"
                                             v-show="help.isBusy"
                                             :size="20"
                                             color="primary"></v-progress-circular>
                    </v-expansion-panel-header>
                    <v-expansion-panel-content>
                        <div v-html="help.htmlDescription"></div>
                    </v-expansion-panel-content>
                </v-expansion-panel>
            </v-expansion-panels>

        </v-container>
    </div>
</template>

<script>
    import HelpGuideService from "../../services/helpGuideService"
    export default {
        name: 'Help',
        data: function () {
            return {
                searchText: "",
                helpGuides: [],
                htmlDescription: ""
            }
        },
        components: {

        },
        methods: {
            async setup() {
                this.accessToken = this.$auth.getAccessToken();
                await this.searchHelpGuides();
            },
            async searchHelpGuides() {
                this.helpGuides = [];
                this.isBusy = true;
                const result = await HelpGuideService.searchHelpGuides(this.accessToken, this.searchText, 1, 1000, "title", "ASCENDING");
                this.helpGuides = result.data.map((obj) => {
                    obj.htmlDescription = "";
                    obj.isBusy = false;
                    return obj;
                });
                this.isBusy = false;
            },
            async onGetHelpHtmlDescription(id) {
                let index = this.helpGuides.findIndex(x => x.id === id && x.htmlDescription === "");

                if (index < 0) {
                    return;
                }

                this.helpGuides[index].isBusy = true;

                const result = await HelpGuideService.getHelpGuideById(id, this.accessToken);

                this.helpGuides[index].htmlDescription = result.htmlDescription;
                this.helpGuides[index].isBusy = false;
            }
        },
        created() {
            this.setup();
        },
        watch: {
            searchText: function () {
                let self = this;
                clearTimeout(this.searchTimer);
                this.searchTimer = setTimeout(function () {
                    self.searchHelpGuides();
                }, 1000);
            }
        }
    }
</script>
